import React, { useEffect, useState } from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LoginPage from "src/auth/SignInForm";
import ReLogin from "src/auth/ReLogin";

import AppLayout from "src/layout/AppLayout";

import Dashboard from "src/common/dashboard/dashboard";

import ScrollToTop from "src/common/base/ScrollToTop";

import modulesList from "src/common/utils/modules";
import NotFound from "src/common/components/404";
import NoAccess from "src/common/components/NoAccess";

import { RouteChildItem, RouteParentItem } from "src/common/types";
import NotificationHistory from "src/navbar-horizontal/notification/NotificationHistory";

import SettingRoutes from "src/modules/setting/routes";
import MobileProfile from "src/navbar-horizontal/MobileProfile";
import coreFunctions from "src/common/utils/coreFunctions";
import ProfileEdit from "src/user/profile-edit/ProfileEdit";
import FortifiedIntelligence from "src/ai/FortifiedIntelligence";

const App: React.FC = () => {
  const [loadRoute, setLoadRoute] = useState(true);
  const [modules, setModules] = useState<RouteParentItem[]>(modulesList);

  useEffect(() => {
    const initMenu = async () => {
      const updatedModules = await Promise.all(
        modules.map(async (route) => {
          try {
            const childs = await import(`src/modules/${route.key}/routes`);
            return { ...route, children: childs.default };
          } catch (err) {
            return route;
          }
        })
      );

      setModules(updatedModules);
      setLoadRoute(false);
    };

    initMenu();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LoginPage />} />

        <Route
          path="/access_denied"
          element={
            <AppLayout>
              <NoAccess />
            </AppLayout>
          }
        />
        <Route
          path="/dashboard"
          element={
            <AppLayout>
              <Dashboard />
            </AppLayout>
          }
        />
        <Route
          path="/fortified_intelligence"
          element={
            <AppLayout>
              <FortifiedIntelligence />
            </AppLayout>
          }
        />
        <Route
          path="/user/profile"
          element={
            <AppLayout>
              <ProfileEdit />
            </AppLayout>
          }
        />
        <Route
          path="/user/profile/:tab"
          element={
            <AppLayout>
              <ProfileEdit />
            </AppLayout>
          }
        />
        <Route
          path="/notification-history"
          element={
            <AppLayout>
              <NotificationHistory />
            </AppLayout>
          }
        />
        {coreFunctions.isMobileDevice() && (
          <Route
            path="/profile"
            element={
              <AppLayout>
                <MobileProfile />
              </AppLayout>
            }
          />
        )}
        {!loadRoute &&
          modules.map((route: RouteParentItem) => {
            if (route.children.length === 0 && route.element) {
              return (
                <Route
                  key={route.key}
                  path={`${route.key}`}
                  element={
                    route.layout ? (
                      React.cloneElement(<>{route.layout}</>, {}, route.element)
                    ) : (
                      <AppLayout>{route.element}</AppLayout>
                    )
                  }
                />
              );
            }

            return route.children.map(
              (child: RouteChildItem, cindex: number) => {
                return (
                  <Route
                    key={`${route.key}-${cindex}`}
                    path={`${child.key}`}
                    element={
                      child.layout ? (
                        React.cloneElement(
                          <>{child.layout}</>,
                          {},
                          child.element
                        )
                      ) : (
                        <AppLayout>{child.element}</AppLayout>
                      )
                    }
                  />
                );
              }
            );
          })}

        {!loadRoute && <Route path="*" element={<NotFound />} />}
        {!loadRoute && <Route path="/expired" element={<ReLogin />} />}

        {!loadRoute &&
          SettingRoutes.map((child: RouteChildItem, index: number) => {
            return (
              <Route
                key={`setting-${index}`}
                path={`${child.key}`}
                element={
                  child.layout ? (
                    React.cloneElement(<>{child.layout}</>, {}, child.element)
                  ) : (
                    <AppLayout>{child.element}</AppLayout>
                  )
                }
              />
            );
          })}
      </Routes>
    </Router>
  );
};

export default App;
